export enum ProductVersionTabs {
    PRODUCT_VERSIONS = 'Product versions',
    PRODUCT_MATERIALS = 'Product materials',
    PRODUCT_FUNCTIONS = 'Product functions',
}
